/**
 * Recruiter Dashboard — static layout seed data.
 *
 * Live widgets (fetched in recruiter-dashboard.component.ts):
 *   - Weekly Activity Metrics  -> /dashboard/weekly-activity-metrics
 *   - Offer Pipeline Tracker   -> /dashboard/offer-pipeline
 *   - Hiring Pipeline funnel + Active Jobs & Total Applicants KPIs
 *                              -> jobs/getBusinessJobPipelineStats
 *   - Today's Activity         -> jobs/getBusinessTodaysActivity
 *
 * Other widgets have no backend API yet. Their mock arrays here are left
 * intentionally empty / zeroed so the card chrome still renders but shows
 * no data — a visible signal to the backend team that these widgets are
 * awaiting their APIs.
 *
 * `insights` (AI Insight strip) retains seed copy per product decision.
 */
export const RECRUITER_MOCK = {
  insights: [
    {
      tone: 'red', tag: 'Urgent',
      body: '<strong>Java Full Stack Dev</strong> closes in 2 days with only 3 applicants. 78% of roles below 5 applicants at close go unfilled. Post to Marketplace now.',
      cta: 'Take action →'
    },
    {
      tone: 'amber', tag: 'Trend',
      body: 'Shortlist-to-interview rate dropped to <strong>40%</strong> this week vs <strong>58%</strong> last month. DevOps and React roles are underperforming. Review JD quality.',
      cta: 'View pipeline →'
    },
    {
      tone: 'green', tag: 'Win',
      body: 'Time-to-fill is <strong>18 days</strong> — 3 days faster than last month and <strong>14% below</strong> industry average. Your screening process is outperforming the market.',
      cta: 'See benchmarks →'
    }
  ],

  // KPI stat cards. Active Jobs + Total Applicants values are overridden live
  // by `kpiOverrides` in the component; the other two await their own API.
  kpis: [
    { accent: 'purple', iconName: 'tablerBriefcase', label: 'Active Jobs',        value: '0', sub: '',               trend: { dir: 'flat', text: '' } },
    { accent: 'green',  iconName: 'tablerUser',      label: 'Total Applicants',   value: '0', sub: '',               trend: { dir: 'flat', text: '' } },
    { accent: 'amber',  iconName: 'tablerCalendar',  label: 'Interviews Today',   value: '0', sub: '',   trend: { dir: 'flat', text: '' } },
    { accent: 'blue',   iconName: 'tablerActivity',  label: 'Time-to-Fill (avg)', value: '0', unit: 'd', sub: '', trend: { dir: 'flat', text: '' } }
  ],

  // ── Awaiting backend APIs (cards render empty) ──────────────────────
  activeJobs: [],
  spotlightTabs: [
    { id: 'applicants', label: 'Applicants', count: 0 },
    { id: 'talent',     label: 'Talent Pool', count: 0 },
    { id: 'market',     label: 'Marketplace', count: 0 }
  ],
  spotlight: [],
  sumoRec: {
    body: 'Your <strong>Java Full Stack Developer</strong> role at Roundclouds has only <strong>3 applicants</strong> with <strong>2 days left</strong> to close. Sumo AI recommends inviting <strong>Sunita Rao</strong> from your Talent Pool (92% match) and posting to the Marketplace immediately — similar roles fill 3× faster with dual-channel sourcing.'
  },
  interviewsToday: [],

  // Today's Activity is already backed by a live API (super-admin only);
  // this empty fallback is used until the first response arrives OR when
  // the user isn't a super-admin.
  todayActivity: [],

  // Hiring Pipeline funnel: live (jobs/getBusinessJobPipelineStats).
  // Keep an empty fallback — template uses `pipelineRows || data.pipeline`.
  pipeline: [],

  applicantsThisWeek: [
    { day: 'Mon', val: 0 },
    { day: 'Tue', val: 0 },
    { day: 'Wed', val: 0 },
    { day: 'Thu', val: 0, active: false },
    { day: 'Fri', val: 0 },
    { day: 'Sat', val: 0 },
    { day: 'Sun', val: 0 }
  ],

};
